import React from 'react';
import { useTranslation } from 'react-i18next';
import { SERVICE_TYPE } from '@src/constants/apiApp';
import { StyledServiceTabs } from './index.style';

const SERVICE_TAB_OPTIONS = [
  { value: SERVICE_TYPE.TTS, labelKey: 'ttsTab' },
  { value: SERVICE_TYPE.STT, labelKey: 'sttTab' },
];

const ServiceTabs = ({ activeTab, onChange }) => {
  const { t } = useTranslation();

  return (
    <StyledServiceTabs>
      {SERVICE_TAB_OPTIONS.map((tab) => (
        <button
          key={tab.value}
          type="button"
          className={`service-tab ${activeTab === tab.value ? 'active' : ''}`}
          onClick={() => onChange(tab.value)}
        >
          {t(tab.labelKey)}
        </button>
      ))}
    </StyledServiceTabs>
  );
};

export default ServiceTabs;
